import { ProductSpec } from "../interface"

export const powerArQ3: ProductSpec = {
  id: 'pa50',
  name: 'PowerArQ 3',
  url: process.env.GATSBY_TARGET_CHANNEL === 'rakuten' ? "https://item.rakuten.co.jp/kashima-tokeiten/pa50/" : "https://powerarq.com/collections/frontpage/products/pa50",
  capacity: 555,
  batteryType: 'マンガン系',
  colors: [
    'coyote-tan',
    'olive-drab',
    'red',
    'charcoal'
  ],
  defaultColor: 'charcoal',
  price: 88000,
  // salePrice: 70400,
  description: 'バッテリー交換システム搭載。必要な容量を運んだり、寿命がきたバッテリーを新しいものに交換することが可能な新モデル',
  chargingTime: 4,
  chargingTimeWithSolar: { input: 150, value: 4 },
  chargingTimeWithCar: { input: 80, value: 13 },
  maximumOutput: 500,
  smartphone: 47,
  electricBlanket: 9,
  fan: 16,
  ledLight: 157,
  riceCooker: 1.7,
  projector: 8,
  fridge: 8,
  electricCarpet: 2,
  acPort: 2,
  usbA: 4,
  usbC: 1,
  qi: 1,
  builtInLed: 710,
  weight: 7.9
}